<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 運送一覧詳細画面 -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form label-position="right" label-width="100px">
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="運送基本情報" name="transBasic">
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>

                <!-- 輸送方式 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.TRANSPORT_METHOD')"
                    class="marginBottom"
                  >
                    <t-input
                      v-model="transEditForm.tbTransMethodShow"
                      class="commonDialog"
                      maxLength="20"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <!-- 出発日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.DEPARTURE_DATE')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-date-picker
                      v-model="transEditForm.tbDepartureDateOnly"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      :clearable="false"
                      format="yyyy/MM/dd"
                      :editable="false"
                    > -->
                    <t-date-picker
                      v-model="transEditForm.tbDepartureDateOnly"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      :clearable="false"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :disabled="!isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-date-picker>
                  </t-form-item>
                </t-col>

                <!-- 到着予定日 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.EXPECT_DATE_ARRIVE')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-date-picker
                      v-model="transEditForm.tbEstArrivalDateOnly"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                    > -->
                    <t-date-picker
                      v-model="transEditForm.tbEstArrivalDateOnly"
                      class="dialogDate"
                      type="date"
                      value-format="yyyy/MM/dd"
                      format="yyyy/MM/dd"
                      :editable="false"
                      :disabled="!isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-date-picker>
                  </t-form-item>
                </t-col>
                <!-- 運送No -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.TRANSPORT_NO')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-input
                      v-model="transEditForm.tbTransOrderNo"
                      class="commonDialog"
                      maxLength="20"
                    > -->
                    <t-input
                      v-model="transEditForm.tbTransOrderNo"
                      class="commonDialog"
                      maxLength="20"
                      :disabled="!isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 目的地 -->
                <t-col :span="colArr.colCom * 2">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.DESTINATION')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-input
                      v-model="transEditForm.tbDestination"
                      class="commonDialog"
                      maxLength="50"
                    > -->
                    <t-input
                      v-model="transEditForm.tbDestination"
                      class="commonDialog"
                      maxLength="50"
                      :disabled="!isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.STATUS')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-select
                      v-model="transEditForm.tbTransStatus"
                      placeholder=""
                      class="commonDialog"
                    > -->
                    <t-select
                      v-model="transEditForm.tbTransStatus"
                      placeholder=""
                      class="commonDialog"
                      :disabled="!isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                      <t-option
                        v-for="item in transStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <!-- 連絡担当 -->
                <t-col :span="colArr.colCom">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.CONNECTER')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-select
                      v-model="transEditForm.tbUserCode"
                      placeholder=""
                      class="commonDialog"
                    > -->
                    <t-select
                      v-model="transEditForm.tbUserCode"
                      placeholder=""
                      class="commonDialog"
                      :disabled="!isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                      <t-option
                        v-for="item in connecterList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR" />
              </t-row>

              <t-row
                type="flex"
                justify="center
          "
              >
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 備考 -->
                <t-col :span="colArr.colCom * 4">
                  <t-form-item
                    :label="$t('resource.TRANSPORT.REMARKS')"
                    class="marginBottom"
                  >
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 日本権限の変更：権限(読み取り)が必要、権限(入力・修正)が不要 -->
                    <!-- <t-input
                      v-model="transEditForm.tbRemarks"
                      type="textarea"
                      maxlength="500"
                      class="commonDialog dialog_bikou"
                      placeholder="備考"
                      show-word-limit
                    > -->
                    <t-input
                      v-model="transEditForm.tbRemarks"
                      type="textarea"
                      maxlength="500"
                      class="commonDialog dialog_bikou"
                      placeholder="備考"
                      show-word-limit
                      :disabled="!isDLUserLocal"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col :span="colArr.colR"></t-col>
              </t-row>
            </t-collapse-item>
          </t-collapse>

          <t-row>
            <t-col
              :span="
                parseInt($t('widgetSize.TRANSPORT_EDIT_DIALOG.SPAN_BTN_THREE'))
              "
              class="col_common_left"
            >
              <!-- 未運送製品選択 -->
              <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
              <!-- <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                ref="selectBtn"
                @click="TransProdSelectDialog"
                :disabled="prodSelectFlg"
              >
                <i class="el-icon-s-order"></i>
                {{ $t("resource.TRANSPORT.TRANSPORT_PROD_SELECT_DIALOG") }}
              </t-button> -->
              &nbsp;
              <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
            </t-col>

            <!-- <t-col :span="16">&nbsp;</t-col> -->
            <t-col :span="20" class="right">
              <!-- 運送単出力 -->
              <t-button
                round
                type="primary"
                class="dialogButton_180_40"
                @click="OutPutClick"
                ref="outputBtn"
                :disabled="btnOutputFlg"
              >
                <i class="el-icon-download"></i>
                {{ $t("resource.TRANSPORT.TRANS_PROC_LIST_OUTPUT") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="24">
            <!-- テーブル -->
            <div>
              <t-table
                ref="transProcInfoTable"
                :data="transProcInfoTable"
                class="table_common"
                header-cell-class-name="bg-default"
                highlight-current-row
                :height="detailHeight"
                :row-class-name="rowClassName"
                :cell-class-name="tableCellClassName"
                border
                fit
              >
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>

                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  class="cell_txt_center"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        circle
                        @click="addRemarksProd(scope.row, $event)"
                      ></t-button>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center'"
                  :width="getRemarksColumnWidthProc()"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                      <!-- 備考編集 -->
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                      <!-- <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        class="bikouButton"
                        circle
                        @click="showRemarksDialogProc(scope.row, $event)"
                      ></t-button> -->
                      <t-button
                        type="warning"
                        icon="el-icon-edit"
                        size="small"
                        class="bikouButton"
                        circle
                        @click="showRemarksDialogProc(scope.row, $event)"
                        :disabled="!isDLUserLocal"
                      ></t-button>
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row>
            <div>
              <t-col :span="24" class="right">
                <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                <!-- <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  @click="transportConfirm"
                  ref="confirmBtn"
                  :disabled="confirmBtnFlg"
                > -->
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  @click="transportConfirm"
                  ref="confirmBtn"
                  :disabled="confirmBtnFlg || !isDLUserLocal"
                >
                  <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->

                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { getUserInfo } from "@/auth";
import { ShowTransProdSelectDialog } from "@/components/Dialog";
import { t } from "@/locales";
import {
  outputExcelToZip,
  showRemarksDialog,
  showRemarksUpdDialog,
} from "@/services/common";
import {
  addTransDetail,
  getTransInitList,
  getTransSelectData,
  searchTransDetailByTransNo,
  updateTransDetail,
} from "@/services/transport";
import {
  cmpBasicData,
  cmpDetailDataExceptRemarks,
  formatCurDateToString,
  formatRemarksShow,
  getAbleUserInfoList,
  getEditColWidthArr,
  getIconType,
  getRemarksColumnWidth,
  ShowMergeExKbn,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NORMAL_PROD,
  NUM_ONE,
  STR_EMPTY,
  STR_ONE,
} from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      activeNames: ["transBasic"],

      // 輸送方式
      transMethodList: [],

      // 運送状態
      transStatusList: [],
      //製品異常区分リスト
      prodExKbnList: [],

      //未運送製品選択ボタンが使用可
      prodSelectFlg: false,
      // 運送製品リスト出力ボタンが使用可
      btnOutputFlg: false,
      //確定ボタンの使用フラグ
      confirmBtnFlg: true,

      //連絡担当
      connecterList: [],

      transEditForm: {
        tbTransMethod: "", // 輸送方式
        tbDepartureDateOnly: "", // 出発日(読み取り用)
        tbDepartureDate: "", // 出発日(保存用)
        tbEstArrivalDateOnly: "", // 到着予定日(読み取り用)
        tbEstArrivalDate: "", // 到着予定日(保存用)
        tbTransOrderNo: "", // 運送No（画面)
        tbTransNo: "", // 運送No

        tbDestination: "", // 目的地
        tbTransStatus: "", // 状態
        tbUserCode: "", // 連絡担当

        tbRemarks: "", // 備考

        tbUpdateTime: "", // 更新時刻
        tbUpdateUser: "", // 更新者
      },

      //運送一覧選択情報
      transProcInfoTable: [],

      //仕入先見積依頼のテーブルの列
      columns: [
        {
          // 配送番号
          prop: "tdTransDetailNo",
          label: t("resource.TRANSPORT.TRANS_DETAIL_NO"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        {
          // 仕入先
          prop: "crbSupCode",
          label: t("resource.TRANSPORT.SUPPLIER_COMPANY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 発送予定詳細機能の追加、運送に変更
        // 入荷日
        /* {
          prop: "crbReceDateOnly",
          label: t("resource.TRANSPORT.RECEIVE_DATE"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        }, */
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // 仕入先納期
        {
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          //prop: "obDueDateOnly",
          prop: "odDueDateOnly",
          // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

          label: t("resource.TRANSPORT.SUPPLIER_DUE_DATE"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 注文No
        {
          prop: "obOrderNoShow",
          label: t("resource.TRANSPORT.ORDER_NO"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.orderInfo.productName"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.orderInfo.pictureNo"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 運送件数
        {
          prop: "tdTransQty",
          label: t("resource.TRANSPORT.TRANSPORT_QUANTITY"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_right",
          overflowTooltip: false,
        },
        // 単位
        {
          prop: "aodProdUnit",
          label: t("resource.TRANSPORT.PRODUCT_UNIT"),
          width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 異常区分
        // {
        //   prop: "tdProdExKbn",
        //   label: t("resource.TRANSPORT.ABNORMAL_DIFFERENCE"),
        //   width: t("widgetSize.TRANSPORT.TABLE_DEFAULT_COLUMN_WIDTH"),
        //   class: "cell_txt_center",
        //   overflowTooltip: false,
        // },
      ],

      localIsAdd: this.isAdd,

      //運送製品選択画面の検索条件
      selectedSearchConditionForm: [],

      //運送明細情報(保存用)
      transDetailInfo: [],

      //基本情報のheight
      //49: collapseのheight 45: 輸送方式のheight　45：目的地　65：備考　45：ボタン
      basicHeight: 49 + 45 + 45 + 65 + 45,
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 画面と文字サイズの調整
      //明細情報のheight  (window.innerHeight * (1 - 0.1) - 65): 画面のheight
      // detailHeight:
      //   window.innerHeight * (1 - 0.1) -
      //   65 -
      //   (49 + 45 + 45 + 65 + 45) -
      //   DIALOG_LINE_HEIGHT -
      //   25,

      detailHeight:
        window.innerHeight * 0.99 -
        65 -
        (49 + 45 + 45 + 65 + 45) -
        DIALOG_LINE_HEIGHT -
        25,
      // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑`

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      showFlag: false,

      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      //権限（false: 日本、true：大連（ 品質保証部））
      isDLUserLocal: false,
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // 読み込み回数
      numLoads: 1,

      // 比較用基本情報
      cmpBasicResult: {},

      // 比較用明細情報
      cmpDetailResult: {},
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
      // 共通備考の調整（備考更新時刻）
      aodUpdateTime: null,
      // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
  },

  // watch: {
  //   "transEditForm.tbTransStatus"(newVal, oldVal) {
  //     //編集、運送状態が運送済みの場合、未運送製品選択ボタンが使用不可
  //     if (newVal == STR_THREE && !this.localIsAdd) {
  //       this.prodSelectFlg = true;
  //     } else {
  //       this.prodSelectFlg = false;
  //     }
  //   },
  // },

  mounted() {
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
    // 権限の取得
    this.isDLUserLocal = sessionStorage.getItem("isDLUser") === "true";
    // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

    this.init(this.rowData);
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      var val = this.activeNames;

      if (val.indexOf("transBasic") !== -1) {
        this.basicHeight = 49 + 45 + 45 + 65 + 45;

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_画面と文字サイズの調整
        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45 + 45 + 65 + 45) -
        //   DIALOG_LINE_HEIGHT -
        //   25;
        this.detailHeight =
          window.innerHeight * 0.99 -
          65 -
          (49 + 45 + 45 + 65 + 45) -
          DIALOG_LINE_HEIGHT -
          25;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      } else {
        this.basicHeight = 49 + 45;

        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_画面と文字サイズの調整
        // this.detailHeight =
        //   window.innerHeight * (1 - 0.1) -
        //   65 -
        //   (49 + 45) -
        //   DIALOG_LINE_HEIGHT -
        //   20;
        this.detailHeight =
          window.innerHeight * 0.99 - 65 - (49 + 45) - DIALOG_LINE_HEIGHT - 20;
        // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
      }

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    //折り畳みパネルの処理
    handleCollapseChange() {
      this.handleResize();
    },

    // 初期化
    init(data) {
      this.showFlag = true;
      ///基本情報のリスト取得（仕入先、担当者）
      getTransInitList()
        .then((res) => {
          //連絡担当リストの取得
          this.connecterList = res.tbUserCode;
          //運送状態
          this.transStatusList = res.tbTransStatus;
          // 輸送方式
          this.transMethodList = res.transMethodList;
          // 製品異常区分リスト
          this.prodExKbnList = res.prodExKbnList;

          //初期値の設定
          this.setInitValue(data);
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });

      // 列幅に自動調整
      setColumnWidth(this.columns, this.transProcInfoTable);
    },

    //初期値の設定
    setInitValue(data) {
      //新規作成の場合
      if (this.localIsAdd) {
        this.activeNames = ["transBasic"];
        this.handleCollapseChange(this.activeNames);

        // 出発日:システム日
        this.transEditForm.tbDepartureDateOnly = new Date();
        // 運送状態：新規
        this.transEditForm.tbTransStatus = STR_ONE;
        // 輸送方式
        this.transEditForm.tbTransMethod = STR_ONE;
        // 連絡担当
        this.transEditForm.tbUserCode = getUserInfo().UserId;
        this.getAbleList();
        this.btnOutputFlg = true;
        this.showFlag = false;
      } else {
        this.activeNames = [""];
        this.handleCollapseChange(this.activeNames);

        this.transEditForm = data;

        //運送No.による運送詳細情報の取得
        this.getTransDetailByTransNo();
        this.btnOutputFlg = false;
        //編集、運送状態が運送済みの場合、未運送製品選択ボタンが使用不可
        // if (this.transEditForm.tbTransStatus == STR_THREE) {
        //   this.prodSelectFlg = true;
        // } else {
        //   this.prodSelectFlg = false;
        // }

        //確定ボタンが使用可能に変更
        this.confirmBtnFlg = false;
      }
    },

    // 使用可能な担当者リストの取得
    getAbleList() {
      // 担当者リスト
      this.connecterList = getAbleUserInfoList(
        this.connecterList,
        this.transEditForm.tbUserCode
      );
    },

    //運送NOによる運送詳細情報の取得
    getTransDetailByTransNo() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      if (!this.transEditForm.tbTransNo || this.transEditForm.tbTransNo == "") {
        this.showFlag = false;
        Message.showError(t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE"));
        return;
      }

      searchTransDetailByTransNo({ tdTransNo: this.transEditForm.tbTransNo })
        .then((res) => {
          this.transProcInfoTable = res.transDetailInfoList;
          this.transEditForm = res.transBasicInfo;
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          // 共通備考の調整（備考更新時刻）
          if (
            res.transDetailInfoList != null &&
            res.transDetailInfoList.length != 0
          ) {
            this.aodUpdateTime = res.transDetailInfoList[0].aodUpdateTime;
          }
          // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          this.transProcInfoTable.map((item) => {
            // 課題_納期分割機能の追加
            item.tdProdExKbnShow = ShowMergeExKbn(
              item.tdProdExKbn,
              item.tdProdReceExKbn
            );
          });
          // ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          // 読み込み回数 = 1
          if (!this.localIsAdd && this.numLoads == 1) {
            // 比較用基本情報
            this.cmpBasicResult = JSON.parse(
              JSON.stringify(this.transEditForm)
            );

            // 比較用明細情報
            this.cmpDetailResult = JSON.parse(
              JSON.stringify(this.transProcInfoTable)
            );

            // 読み込み回数 + 1
            this.numLoads = this.numLoads + 1;
          }

          this.getAbleList();
          // 列幅に自動調整
          setColumnWidth(this.columns, this.transProcInfoTable);
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    //「確定」ボタン
    transportConfirm() {
      // this.$message("運送台帳データを作成する");
      if (this.transProcInfoTable.length >= NUM_ONE) {
        if (this.localIsAdd) {
          //運送台帳新規作成
          this.addTransDetailProc();
        } else {
          //運送台帳編集保存
          this.updTransDetailProc();
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    // 運送詳細情報の更新
    updTransDetailProc() {
      this.dataAddUpdProc();

      updateTransDetail({
        transBasicInfo: this.transEditForm,
        transDetailInfoList: this.transDetailInfo,
      })
        .then((res) => {
          this.numLoads = 1;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          //検索処理を行う
          this.getTransDetailByTransNo();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
          this.showFlag = false;
        });
      // .finally(() => {
      //   //検索処理を行う
      //   this.getTransDetailByTransNo();
      // });
    },

    //運送明細情報の追加
    addTransDetailProc() {
      //保存前、データ処理
      this.dataAddUpdProc();
      addTransDetail({
        transBasicInfo: this.transEditForm,
        transDetailInfoList: this.transDetailInfo,
      })
        .then((res) => {
          this.transEditForm.tbTransNo = res;
          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          this.localIsAdd = false;
          this.btnOutputFlg = false;
          //検索処理を行う
          this.getTransDetailByTransNo();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
          this.showFlag = false;
        });
      // .finally(() => {
      //   //検索処理を行う
      //   this.getTransDetailByTransNo();
      // });
    },

    // 更新/追加されたデータ処理
    dataAddUpdProc() {
      // 出発日
      this.transEditForm.tbDepartureDate = formatCurDateToString(
        this.transEditForm.tbDepartureDateOnly
      );

      // 到着予定日
      this.transEditForm.tbEstArrivalDate = formatCurDateToString(
        this.transEditForm.tbEstArrivalDateOnly
      );

      this.transEditForm.tbUpdateUser = getUserInfo().UserId;

      this.transDetailInfo = [];
      for (let index = 0; index < this.transProcInfoTable.length; index++) {
        const element = this.transProcInfoTable[index];

        this.transDetailInfo.push({
          tdTransNo: this.transEditForm.tbTransNo, // 運送No
          // UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
          // 運送単の運送単号の改修
          // tdTransDetailNo: index + 1, // 運送明細No
          tdTransDetailNo: element.tdTransDetailNo, // 運送明細No
          // UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 発送予定詳細機能の追加、運送に変更
          // tdCReceNo: element.tdCReceNo, // 入荷No.
          // tdCReceDetailNo: element.tdCReceDetailNo, // 入荷明細No.

          tdOrderNo: element.obOrderNo, //手配NO.
          tdDetailNo: element.tdDetailNo, //手配明細No.
          // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          tdQuoteNo: element.tdQuoteNo, // 見積No
          // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
          // 課題_納期分割機能の追加
          // tdProdExKbn: this.prodExKbnList.find(
          //   (it) => it.statusColor === element.tdProdExKbn
          // )?.value, // 製品異常区分
          tdProdExKbn: element.tdProdExKbn, // 製品異常区分
          // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
          tdProdNo: element.tdProdNo, //受注明細No.
          tdTransQty: element.tdTransQty, //運送件数
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // crbUpdateTime: element.crbUpdateTime, //検査室入荷更新時刻
          // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
          tdUpdateUser: getUserInfo().UserId, //更新者
        });
      }
    },

    // 製品異常
    rowClassName({ row }) {
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
      // 課題_納期分割機能の追加
      /* if (!!row.tdProdExKbn && row.tdProdExKbn != STR_EMPTY) {
        if (row.tdProdExKbn != NORMAL_PROD) {
          return "textColor";
        }
      } */
      if (row.tdProdExKbnShow != NORMAL_PROD) {
        return "textColor";
      }
      // UPD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑
    },

    //列幅に自動調整
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.transProcInfoTable);
    },

    // 運送製品選択画面を表示
    TransProdSelectDialog() {
      ShowTransProdSelectDialog(
        {
          tableData: this.transProcInfoTable,
          tdTransNo: this.transEditForm.tbTransNo,
          selectedSearchForm: this.selectedSearchConditionForm,
        },
        t("resource.TRANSPORT.TRANSPORT_PROD_SELECT_DIALOG"),
        (target) => {
          if (!!target) {
            this.selectedSearchConditionForm = target.find(
              (item) => item.key === "searchConditionForm"
            )?.value;

            if (this.selectedSearchConditionForm.searchTransMethod) {
              this.transEditForm.tbTransMethod =
                this.selectedSearchConditionForm.searchTransMethod;
            } else {
              this.transEditForm.tbTransMethod = STR_ONE;
            }
            this.transEditForm.tbTransMethodShow = this.transMethodList.find(
              (item) =>
                item.value ===
                this.selectedSearchConditionForm.searchTransMethod
            )?.label;

            //運送一覧選択情報
            let selectData = target.find(
              (item) => item.key === "selectedProcForm"
            )?.value;

            getTransSelectData({
              transDetailInfoList: selectData,
            })
              .then((res) => {
                let transProcInfoTable = this.transProcInfoTable;
                let transProcSelectData = res.transDetailInfoList;

                transProcSelectData.forEach((item) => {
                  let existingProductIndex = transProcInfoTable.findIndex(
                    (p) =>
                      p.tdCReceNo == item.tdCReceNo &&
                      p.tdCReceDetailNo == item.tdCReceDetailNo
                  );

                  if (existingProductIndex == -1) {
                    this.transProcInfoTable.push(item);
                  }
                });

                this.transProcInfoTable = this.transProcInfoTable.filter((p) =>
                  transProcSelectData.some(
                    (t) =>
                      p.tdCReceNo == t.tdCReceNo &&
                      p.tdCReceDetailNo == t.tdCReceDetailNo
                  )
                );

                for (
                  let index = 0;
                  index < this.transProcInfoTable.length;
                  index++
                ) {
                  this.transProcInfoTable[index].tdTransDetailNo = index + 1;
                }
                // 列幅に自動調整
                setColumnWidth(this.columns, this.transProcInfoTable);
              })
              .catch((err) => {
                if (err.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(
                    t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                  );
                }
              });

            //確定ボタンが使用可能に変更
            this.confirmBtnFlg = false;

            setColumnWidth(this.columns, this.transProcInfoTable);
          }
        }
      );

      // フォーカス削除
      this.$refs.selectBtn.$el.blur();
    },

    // 「運送単出力」ボタン
    OutPutClick() {
      this.showFlag = true;
      if (typeof this.$refs.outPutBtn !== "undefined") {
        // フォーカス削除
        this.$refs.outPutBtn.$el.blur();
      }

      if (!this.showFlag) {
        this.showFlag = true;
      }

      //保存前、データ処理
      this.dataAddUpdProc();

      updateTransDetail({
        transBasicInfo: this.transEditForm,
        transDetailInfoList: this.transDetailInfo,
      })
        .then((res) => {
          this.numLoads = 1;
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.outputProcess();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
    },

    outputProcess() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      outputExcelToZip(httpApi.OutPutTransportToExcel, {
        tdTransNo: this.transEditForm.tbTransNo,
        tableData: this.transProcInfoTable,
      }).finally(() => {
        this.showFlag = false;
        //検索処理を行う
        this.getTransDetailByTransNo();
      });
    },

    // ダイアログを閉じる
    onCancel() {
      let isDataChanged = false;
      if (this.localIsAdd) {
        isDataChanged = this.transProcInfoTable.length > 0;
      } else {
        isDataChanged =
          !cmpBasicData(this.cmpBasicResult, this.transEditForm) ||
          // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
          //  !cmpDetailData(this.cmpDetailResult, this.transProcInfoTable);
          !cmpDetailDataExceptRemarks(
            this.cmpDetailResult,
            this.transProcInfoTable,
            ["aodProdRemarksSum", "aodProdRemarks", "aodUpdateTime", "index"]
          );
        // UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
      }

      if (isDataChanged) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    addRemarksProd(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }
      let remarks = STR_EMPTY;
      showRemarksUpdDialog(
        this,
        row.tdQuoteNo,
        row.tdProdNo,
        row.aodProdRemarksSum
      )
        .then((res) => {
          remarks = res;
        })
        .finally(() => {
          this.numLoads = 1;
          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
          if (remarks != STR_EMPTY) {
            // //　比較用明細情報の備考を変更する
            if (this.cmpDetailResult.length > 0) {
              this.cmpDetailResult.forEach((item) => {
                // 手配NO.と手配明細NO.一致の場合、備考を変更する
                if (
                  item.obOrderNo === row.obOrderNo &&
                  item.tdDetailNo === row.tdDetailNo
                ) {
                  item.aodProdRemarksSum = remarks;
                }
              });
            }
            // 備考を更新する
            row.aodProdRemarksSum = remarks;
          }
        });
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.transProcInfoTable);
    },

    //共通備考の調整（備考の表示と保存）
    showRemarksDialogProc(row, event) {
      // フォーカス削除
      event.currentTarget.blur();
      if (!this.showFlag) {
        this.showFlag = true;
      }
      showRemarksDialog(
        this,
        row.tdQuoteNo,
        row.tdProdNo,
        row.aodProdRemarksSum,
        row.aodProdRemarksSum,
        // UPD 2025/08/19 WZC 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正 start↓
        // this.aodUpdateTime
        row.aodUpdateTime
        // UPD 2025/08/19 WZC 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正 end↑
      )
        .then((res) => {
          if (!this.isEmptyOrNull(res)) {
            // 備考を更新する
            row.aodProdRemarksSum = res.aodProdRemarks;
            // UPD 2025/08/19 WZC 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正 start↓
            // this.aodUpdateTime = res.aodUpdateTime;
            row.aodUpdateTime = res.aodUpdateTime;
            this.transProcInfoTable
              .filter((item) => item.tdQuoteNo === row.tdQuoteNo)
              .forEach((item) => {
                item.aodUpdateTime = row.aodUpdateTime;
              });
            // UPD 2025/08/19 WZC 内部バグ_「複数の見積番号、備考入力保存時に排他メッセージが表示される」問題の修正 end↑
            this.$set(this.transProcInfoTable, row.index, row);
          }
        })
        .finally(() => {
          this.numLoads = 1;
          // 待ちダイアログを閉じる
          if (this.showFlag) {
            this.showFlag = false;
          }
        });
    },
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },
    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
.el-table__body {
  height: 200px;
}
</style>
